import { serializeError } from "serialize-error";
import getBrowserErrorType from "./getBrowserErrorType.js";
import { FetchPromise, RequestTimeoutError, NetworkRequestFailedError, ServiceResponseError } from "./services/ServiceBase.js";
const _Logging = class _Logging {
  static critical(error) {
    if (typeof window.console !== "undefined") {
      console.error(error);
    }
    return this.logToServer(
      error,
      "Critical"
      /* Critical */
    );
  }
  static error(error) {
    if (typeof window.console !== "undefined") {
      console.error(error);
    }
    return this.logToServer(
      error,
      "Error"
      /* Error */
    );
  }
  static initialize(postLog, siteUrl, buildNumber, environment, logLevels = []) {
    this.buildNumber = buildNumber;
    this.environment = environment;
    this.logLevels = logLevels;
    this.postLog = postLog;
    let siteOrigin = siteUrl == null ? void 0 : siteUrl.toLowerCase();
    if (!siteOrigin) {
      siteOrigin = window.location.origin.toLowerCase();
    }
    window.addEventListener("error", (event) => {
      if (typeof window.console !== "undefined") {
        console.error(event.error);
      }
      const fileName = event.filename.toLowerCase();
      if (!fileName || !fileName.includes(".js") || !fileName.startsWith(siteOrigin)) {
        return;
      }
      const errorInfo = {
        file: event.filename + ":" + event.lineno.toString() + ":" + event.colno.toString(),
        message: event.message ? event.message : "[no message]",
        type: "window.error"
      };
      void _Logging.logToServer(event.error, "Error", errorInfo, true);
    });
    window.addEventListener("unhandledrejection", (event) => {
      var _a;
      if (typeof window.console !== "undefined") {
        console.error(event.reason);
      }
      const reason = event.reason;
      const stack = (_a = reason == null ? void 0 : reason.stack) == null ? void 0 : _a.toLowerCase();
      if (typeof stack !== "string" || !stack.includes(".js") || !stack.includes(siteOrigin)) {
        return;
      }
      const errorInfo = {
        type: "window.unhandledrejection"
      };
      void _Logging.logToServer(event.reason, "Error", errorInfo, true);
    });
  }
  static log(message) {
    if (typeof window.console !== "undefined") {
      console.log(message);
    }
    return this.logToServer(
      message,
      "Info"
      /* Info */
    );
  }
  static warning(message) {
    if (typeof window.console !== "undefined") {
      console.warn(message);
    }
    return this.logToServer(
      message,
      "Warning"
      /* Warning */
    );
  }
  static logToServer(message, errorLogLevel, additionalInfo, noLocalStack) {
    if (this.environment === "Local") {
      return new FetchPromise((resolve) => resolve(void 0));
    }
    let errorObject = serializeError(message);
    if (!errorObject || typeof errorObject !== "object") {
      errorObject = { error: errorObject };
    }
    let stackTrace = errorObject.stack ?? "";
    delete errorObject.stack;
    if (additionalInfo) {
      errorObject = {
        ...additionalInfo,
        error: errorObject
      };
    }
    if (typeof message === "object" && (message == null ? void 0 : message.constructor.name)) {
      errorObject.className = message.constructor.name;
    }
    let messageToSend = JSON.stringify(errorObject, null, 2);
    messageToSend += "\n\nBuild Number: " + (this.buildNumber ?? "0");
    if (!noLocalStack) {
      stackTrace += "\n\n" + (new Error().stack ?? "");
    }
    let adjustedLogLevel = errorLogLevel;
    if (message instanceof RequestTimeoutError || message instanceof NetworkRequestFailedError || message instanceof ServiceResponseError || getBrowserErrorType(message) !== null) {
      adjustedLogLevel = "Warning";
    }
    if (this.logLevels.length > 0 && !this.logLevels.includes(adjustedLogLevel.toLowerCase())) {
      return new FetchPromise((resolve) => resolve(void 0));
    }
    return new FetchPromise((resolve) => {
      if (!stackTrace) {
        resolve(this.logToServerCall(errorLogLevel, messageToSend));
      }
      messageToSend += "\n\nStacktrace:\n" + stackTrace;
      resolve(this.logToServerCall(adjustedLogLevel, messageToSend));
    });
  }
  static logToServerCall(errorLogLevel, message, isRetry) {
    this.activity(message);
    if (!this.postLog) {
      if (!isRetry) {
        window.setTimeout(
          () => this.logToServerCall(errorLogLevel, message, true),
          1e3
        );
      } else if (typeof window.console !== "undefined") {
        console.warn("Logging.postLog is not defined.");
      }
      return new FetchPromise((resolve) => resolve(void 0));
    }
    return this.postLog({
      body: {
        level: errorLogLevel,
        message,
        url: typeof window.location !== "undefined" ? window.location.pathname + window.location.search : ""
      },
      timeoutSeconds: 3
    }).then((result) => {
      if (![
        "Error",
        "Critical"
        /* Critical */
      ].includes(errorLogLevel)) {
        result.traceId = null;
      }
      return result;
    }).catch((ex) => {
      if (typeof window.console !== "undefined") {
        console.error(ex);
      }
      return void 0;
    });
  }
};
_Logging.buildNumber = null;
_Logging.environment = null;
_Logging.logLevels = [];
_Logging.postLog = null;
_Logging.activity = () => {
};
let Logging = _Logging;
export {
  Logging as default
};
//# sourceMappingURL=Logging.js.map
